import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'];

const WeeklyTrends = ({ data }) => {
    if (!data || data.length === 0) return null;

    const labels = data.map(w => w.label);
    const revenue = data.map(w => w.revenue);
    const orders = data.map(w => w.orders);
    const colors = labels.map((_, i) => COLORS[i % COLORS.length]);

    const chartData = {
        labels,
        datasets: [
            {
                label: 'Revenue (BHD)',
                data: revenue,
                backgroundColor: colors,
                borderRadius: 4,
                yAxisID: 'y',
            },
            {
                label: 'Orders',
                data: orders,
                backgroundColor: 'rgba(16,185,129,0.5)',
                borderRadius: 4,
                yAxisID: 'y1',
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { position: 'top' },
        },
        scales: {
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                title: { display: true, text: 'Revenue (BHD)' },
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                title: { display: true, text: 'Orders' },
                grid: { drawOnChartArea: false },
            },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Weekly Trends</h6>
                <Bar data={chartData} options={options} />
                <div className="table-responsive mt-3">
                    <table className="table table-sm table-bordered mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Week</th>
                                <th>Days</th>
                                <th className="text-end">Revenue (BHD)</th>
                                <th className="text-end">Orders</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((w, i) => (
                                <tr key={i}>
                                    <td>{w.label}</td>
                                    <td>{w.day_range}</td>
                                    <td className="text-end">{w.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                    <td className="text-end">{w.orders}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default WeeklyTrends;
